import { score } from './score';
import { pickMultiple } from './weightedRandom';

const pickExperts = (experts, num, distribution, scoreFn = score) => {
  const now = Date.now();
  const weightedExperts = Object.entries(experts)
    .map(([id, { partnerId, rating, lastAcceptedAt } = {}]) => ({
      id,
      weight: scoreFn({
        partnerId,
        distribution,
        rating: rating ?? undefined,
        msSinceActive: lastAcceptedAt ? now - lastAcceptedAt : undefined,
      }),
    }));

  return pickMultiple(weightedExperts, num);
};

// eslint-disable-next-line import/prefer-default-export
export { pickExperts };
